module.exports = __webpack_public_path__ + "assets/img/flpp.028013a2.jpg";